export const FacebookIcon = () => {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.2H8.14286L9 6H6V4.4C6 3.576 6 2.8 7.71429 2.8H9V0.112C8.72057 0.0776001 7.66543 0 6.55114 0C4.224 0 2.57143 1.3256 2.57143 3.76V6H0V9.2H2.57143V16H6V9.2Z"
        fill="white"
      />
    </svg>
  );
};

export const TwitterIcon = () => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9992 1.66195C16.3625 1.94721 15.6873 2.13455 14.9959 2.21778C15.7246 1.77636 16.27 1.08164 16.5305 0.263089C15.8466 0.675315 15.0968 0.964211 14.3154 1.12048C13.7905 0.551629 13.0947 0.174362 12.3363 0.0473339C11.5779 -0.0796944 10.7993 0.0506337 10.1215 0.418057C9.44373 0.78548 8.90481 1.36941 8.5885 2.07907C8.27219 2.78873 8.19622 3.58436 8.3724 4.34226C6.98557 4.27186 5.62886 3.90683 4.39035 3.27087C3.15184 2.63491 2.05922 1.74224 1.18343 0.650818C0.873427 1.19013 0.71052 1.80321 0.711391 2.42727C0.711391 3.65212 1.32687 4.73422 2.26261 5.36776C1.70885 5.3501 1.16728 5.19863 0.683036 4.92597V4.96989C0.683203 5.78564 0.961895 6.57623 1.47186 7.20762C1.98183 7.839 2.69168 8.27232 3.48106 8.43411C2.96701 8.57521 2.42799 8.59601 1.90483 8.49493C2.12739 9.19709 2.56118 9.81118 3.14546 10.2512C3.72974 10.6912 4.43525 10.9352 5.16322 10.9489C4.43972 11.5244 3.61131 11.9498 2.72537 12.2009C1.83943 12.4519 0.913323 12.5236 0 12.4119C1.59433 13.4504 3.45029 14.0018 5.34586 14C11.7617 14 15.2703 8.61657 15.2703 3.94778C15.2703 3.79573 15.2661 3.64199 15.2595 3.49163C15.9424 2.99169 16.5318 2.37238 17 1.6628L16.9992 1.66195Z"
      fill="white"
    />
  </svg>
);

export const WhatsappIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0032107 17L1.08481 12.7772C0.372121 11.4791 -0.0023125 10.0028 1.07458e-05 8.49999C1.07458e-05 3.80545 3.58161 0 8.00001 0C12.4184 0 16 3.80545 16 8.49999C16 13.1945 12.4184 17 8.00001 17C6.58623 17.0024 5.19733 16.6049 3.97601 15.8482L0.0032107 17ZM5.11281 4.5118C5.0095 4.51861 4.90855 4.54752 4.81601 4.5968C4.72922 4.64901 4.65 4.71429 4.58081 4.7906C4.48481 4.88665 4.43041 4.96995 4.37201 5.0507C4.07634 5.45954 3.9173 5.9614 3.92001 6.477C3.92161 6.8935 4.02401 7.29894 4.18401 7.67804C4.51121 8.44474 5.04961 9.25649 5.76081 10.0087C5.93201 10.1898 6.09921 10.3717 6.27921 10.5408C7.16192 11.3666 8.21381 11.9621 9.3512 12.2799L9.8064 12.3539C9.9544 12.3624 10.1024 12.3505 10.2512 12.3428C10.4842 12.3301 10.7117 12.263 10.9176 12.1465C11.0504 12.0717 11.1128 12.0343 11.224 11.9595C11.224 11.9595 11.2584 11.9357 11.324 11.883C11.432 11.798 11.4984 11.7376 11.588 11.6382C11.6544 11.5651 11.712 11.4792 11.756 11.3815C11.8184 11.2429 11.8808 10.9786 11.9064 10.7584C11.9256 10.5901 11.92 10.4983 11.9176 10.4414C11.9144 10.3504 11.8432 10.2561 11.7656 10.2161L11.3 9.99429C11.3 9.99429 10.604 9.67214 10.1792 9.46644C10.1344 9.4457 10.0864 9.43389 10.0376 9.43159C9.98287 9.42562 9.92756 9.43216 9.8754 9.45078C9.82325 9.4694 9.77544 9.49967 9.7352 9.53954V9.53784C9.7312 9.53784 9.6776 9.58629 9.0992 10.3309C9.06601 10.3783 9.02028 10.4141 8.96785 10.4338C8.91542 10.4535 8.85866 10.4561 8.8048 10.4414C8.75268 10.4266 8.70162 10.4078 8.652 10.3853C8.5528 10.3411 8.5184 10.3241 8.45041 10.2926L8.4464 10.2909C7.98873 10.0786 7.56498 9.79186 7.19041 9.44094C7.08961 9.34744 6.99601 9.24544 6.90001 9.14684C6.58527 8.8266 6.31098 8.4643 6.08401 8.06905L6.03681 7.98829C6.0029 7.93403 5.97549 7.8755 5.95521 7.81404C5.92481 7.68909 6.00401 7.5888 6.00401 7.5888C6.00401 7.5888 6.19841 7.36269 6.28881 7.24029C6.36408 7.13857 6.43431 7.03274 6.49921 6.92325C6.59361 6.76175 6.62321 6.596 6.57361 6.46765C6.34961 5.88625 6.11761 5.3074 5.87921 4.7328C5.83201 4.6189 5.69201 4.5373 5.56481 4.52115C5.52161 4.51605 5.47841 4.51095 5.43521 4.50755C5.32777 4.50188 5.22011 4.50301 5.11281 4.51095V4.5118Z"
      fill="white"
    />
  </svg>
);

export const LinkedIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6311 12.7825H11.2622V9.30167C11.2622 8.47167 11.2444 7.40333 10.0267 7.40333C8.792 7.40333 8.60356 8.30667 8.60356 9.24083V12.7825H6.23378V5.625H8.50933V6.6H8.54044C8.85867 6.03833 9.632 5.44417 10.7876 5.44417C13.1876 5.44417 13.632 6.92583 13.632 8.85333V12.7825H13.6311ZM3.55822 4.64583C3.37738 4.64605 3.19828 4.61281 3.03117 4.54801C2.86406 4.4832 2.71224 4.38812 2.58441 4.2682C2.45657 4.14828 2.35525 4.00588 2.28623 3.84918C2.21722 3.69247 2.18187 3.52454 2.18222 3.355C2.1824 3.09986 2.26327 2.8505 2.41461 2.63846C2.56596 2.42641 2.78097 2.26119 3.03247 2.16371C3.28397 2.06623 3.56065 2.04085 3.82754 2.09078C4.09442 2.14072 4.33952 2.26373 4.53183 2.44426C4.72414 2.62478 4.85503 2.85472 4.90796 3.10498C4.96088 3.35525 4.93345 3.61461 4.82914 3.85026C4.72483 4.08592 4.54833 4.28728 4.32195 4.42889C4.09557 4.5705 3.82948 4.646 3.55733 4.64583H3.55822ZM4.74578 12.7825H2.36978V5.625H4.74667V12.7825H4.74578ZM14.8178 0H1.18133C0.527111 0 0 0.483333 0 1.08083V13.9192C0 14.5167 0.528 15 1.18044 15H14.8142C15.4667 15 16 14.5167 16 13.9192V1.08083C16 0.483333 15.4667 0 14.8142 0H14.8169H14.8178Z"
      fill="white"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.0508 10.514L4.64413 8.65599C4.31713 8.98059 3.90134 9.20111 3.44919 9.28975C2.99704 9.37838 2.52877 9.33117 2.10342 9.15406C1.67806 8.97695 1.31466 8.67787 1.05903 8.29453C0.803405 7.91119 0.666992 7.46075 0.666992 6.99999C0.666992 6.53924 0.803405 6.0888 1.05903 5.70545C1.31466 5.32211 1.67806 5.02304 2.10342 4.84593C2.52877 4.66882 2.99704 4.6216 3.44919 4.71024C3.90134 4.79888 4.31713 5.01939 4.64413 5.34399L8.0508 3.48599C7.93396 2.93782 8.01835 2.3659 8.28853 1.87483C8.55871 1.38376 8.99663 1.00635 9.5222 0.811615C10.0478 0.616883 10.6259 0.617842 11.1508 0.814317C11.6757 1.01079 12.1124 1.38965 12.3809 1.88162C12.6495 2.37358 12.732 2.94578 12.6133 3.49356C12.4947 4.04135 12.1828 4.52812 11.7347 4.86486C11.2867 5.2016 10.7324 5.36581 10.1732 5.32746C9.61404 5.28911 9.08735 5.05076 8.68947 4.65599L5.2828 6.51399C5.35076 6.83443 5.35076 7.16556 5.2828 7.48599L8.68947 9.34399C9.08735 8.94923 9.61404 8.71088 10.1732 8.67253C10.7324 8.63418 11.2867 8.79838 11.7347 9.13513C12.1828 9.47187 12.4947 9.95864 12.6133 10.5064C12.732 11.0542 12.6495 11.6264 12.3809 12.1184C12.1124 12.6103 11.6757 12.9892 11.1508 13.1857C10.6259 13.3821 10.0478 13.3831 9.5222 13.1884C8.99663 12.9936 8.55871 12.6162 8.28853 12.1252C8.01835 11.6341 7.93396 11.0622 8.0508 10.514Z"
      fill="white"
    />
  </svg>
);

export const RightArrow = () => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.48917 8.90929L0.63916 2.05929L2.59591 0.102539L11.4027 8.90929L2.59591 17.7161L0.63916 15.7593L7.48917 8.90929Z"
      fill="white"
    />
  </svg>
);

export const LeftArrow = () => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.28818 8.90929L11.1382 2.05929L9.18143 0.102539L0.374679 8.90929L9.18143 17.7161L11.1382 15.7593L4.28818 8.90929Z"
      fill="white"
    />
  </svg>
);

export const StartIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 38C8.5063 38 0 29.4937 0 19C0 8.5063 8.5063 0 19 0C29.4937 0 38 8.5063 38 19C38 29.4937 29.4937 38 19 38ZM19 34.2C23.0313 34.2 26.8975 32.5986 29.748 29.748C32.5986 26.8975 34.2 23.0313 34.2 19C34.2 14.9687 32.5986 11.1025 29.748 8.25198C26.8975 5.40142 23.0313 3.8 19 3.8C14.9687 3.8 11.1025 5.40142 8.25198 8.25198C5.40142 11.1025 3.8 14.9687 3.8 19C3.8 23.0313 5.40142 26.8975 8.25198 29.748C11.1025 32.5986 14.9687 34.2 19 34.2ZM16.3818 12.1885L25.6519 18.3673C25.7561 18.4367 25.8416 18.5307 25.9008 18.6411C25.9599 18.7515 25.9908 18.8748 25.9908 19C25.9908 19.1252 25.9599 19.2485 25.9008 19.3589C25.8416 19.4693 25.7561 19.5633 25.6519 19.6327L16.3799 25.8115C16.2656 25.8873 16.1329 25.9307 15.9959 25.9372C15.8588 25.9437 15.7226 25.9129 15.6017 25.8483C15.4807 25.7836 15.3795 25.6874 15.3088 25.5699C15.2381 25.4523 15.2005 25.3179 15.2 25.1807V12.8193C15.2003 12.6818 15.2378 12.547 15.3086 12.4292C15.3794 12.3114 15.4809 12.215 15.6021 12.1502C15.7234 12.0855 15.86 12.0549 15.9973 12.0616C16.1346 12.0684 16.2675 12.1122 16.3818 12.1885Z"
      fill="#0CB945"
    />
  </svg>
);
